import {transactionsSlice} from './slice';

export default transactionsSlice.reducer;
